import axios from "axios"
import { env } from "../constants"

export const list = (token, params = {}) => {
    const uri = `${env.startpoint}notifications`
    const headers = { headers: { Authorization: `Bearer ${token}` }, params }
    return axios.get(uri, headers).then(response => response).catch(error => error.response)
}

export const read = (token, id) => {
    const uri = `${env.startpoint}notifications/${id}/read`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.patch(uri, {}, headers).then(response => response).catch(error => error.response)
}

export const readAll = token => {
    const uri = `${env.startpoint}notifications/read-all`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, {}, headers).then(response => response).catch(error => error.response)
}

export const unreadCount = token => {
    const uri = `${env.startpoint}notifications/unread-count`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then(response => response).catch(error => error.response)
}

export const settings = token => {
    const uri = `${env.startpoint}notifications/settings`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then(response => response).catch(error => error.response)
}

export const updateSettings = (token, data) => {
    const uri = `${env.startpoint}notifications/settings`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.patch(uri, data, headers).then(response => response).catch(error => error.response)
}

export const registerDevice = (token, data) => {
    const uri = `${env.startpoint}notifications/devices`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(error => error.response)
}

export const removeDevice = (token, deviceToken) => {
    const uri = `${env.startpoint}notifications/devices/${deviceToken}`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.delete(uri, headers).then(response => response).catch(error => error.response)
}
